import React, { useEffect, useState } from 'react'
import { ConfirmReserveByUser_Reserve_Api, GetById_Reserve_Api } from '../../API/ReserveApi';
import { TimesComponent } from './TimesComponent';
import { OthersComponent } from './OthersComponent';
import { ObjectsComponent } from './ObjectsComponent';
import { Button, Col, Row } from 'antd';
import { Steps } from '../Step/Steps';
import { ObjectFieldsComponent } from './ObjectFieldsComponent';
import { AFactorComponent } from '../Factor/AFactorComponent';
import {
    CloseOutlined,
    DoubleRightOutlined,
    EditOutlined,
} from '@ant-design/icons';
import { AReserveComponent } from './AReserveComponent';
import { ReservePlaceAndTimeComponent } from './ReservePlaceAndTimeComponent';
// import { PrimaryUserInfoComponent } from './PrimaryUserInfoComponent';
// import { AdditionalFilesComponent } from './AdditionalFilesComponent';

// ====================================================================== 
export const EditableReserveComponent = ({
    setLoading,
    showMessage,
    printType,
    period,
    reserveId,
    factorFirst = true,
    showSteps = true,
   loadReserve: parentLoadReserve,
  //version    ,
   //onReserveUpdated // 🔥 دریافت تابع callback
}) => {
    // ====================================================================== 
    const [reserve, setReserve] = useState();
    const [view, setView] = useState("PreConfirmReserve");
    const [internalVersion, setInternalVersion] = useState(0); // 🔥 نسخه داخلی
    //const [version, setversion] = useState(version); // 🔥 نسخه داخلی
    //  const [mobile, setMobile] = useState();
    //   const [tel, setTel] = useState();
    //   const [address, setAddress] = useState();
    //   const [postalCode, setPostalCode] = useState();
    // ======================================================================
    useEffect(() => {
        loadReserve();
    }, [internalVersion]);
    // ======================================================================    
    const loadReserve  = async () => {
        setLoading(true);
        try {
            const data = await GetById_Reserve_Api(reserveId);
            setLoading(false);
            if (data.messageStatus == "Successful"){
                setReserve(data.messageData.data);
        //     setMobile(data.messageData.data.mobile);
        // setTel(data.messageData.data.tel);
        // setAddress(data.messageData.data.address);
        // setPostalCode(data.messageData.data.postalCode);
      }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
      // در دکمه‌های بازگشت:
    const handleBackFromEdit = () => {
        setInternalVersion(prev => prev + 1); // 🔥 آپدیت نسخه داخلی
        //setVersion(prev => prev + 1);
       if (typeof parentLoadReserve === 'function') {
      parentLoadReserve();
    }
        setView("PreConfirmReserve");
        // 🔥 فراخوانی loadReserve پس از بازگشت
       // if (onReserveUpdated) {
        //    onReserveUpdated();
       // }
    }
    // ======================================================================    
    const confirmReserve = async () => {
        setLoading(true);
        try {
            const data = await ConfirmReserveByUser_Reserve_Api(reserveId);
            setLoading(false)
            if (data.messageStatus == "Successful") {
                showMessage(data.message, "Successful");
                setView("ConfirmedReserve");
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // ======================================================================    
    return (
        reserve ?
            <>
                {view == "EditOthers" ?
                    (
                        <>
                            <Row className='sectionTitle  no-print'>
                                <Col xs={14} sm={14} md={16} lg={20} xl={20}>
                                    <h2>
                                       لیست نفرات
                                    </h2>
                                </Col>
                                <Col xs={10} sm={10} md={8} lg={4} xl={4} >
                                
                                    <Button
                                        className='btn-secondary'
                                        onClick={handleBackFromEdit}
                                        style={{ width: '100%' }} >
                                        <DoubleRightOutlined />
                                        بازگشت
                                    </Button>
                                </Col>
                            </Row>
                            {/* hrr todo reserve.reserveStatus */}
                            <OthersComponent
                                printType={printType}
                                mode={ 'Edit'}
                                showTitleBar={true}
                                period={period}
                                setLoading={setLoading}
                                showMessage={showMessage}
                                reserveId={reserve.id}
                                reserve={reserve}
                                stepChanged={() => { loadReserve() }}
                            />
                            {/* <PrimaryUserInfoComponent
                                            setLoading={setLoading}
                                            showMessage={showMessage}
                                             mobile={mobile}
                                            tel={tel}
                                            address={address}
                                            setMobile={setMobile}
                                            setAddress={setAddress}
                                            setTel={setTel}
                                            setReserve={setReserve}
                                            postalCode={postalCode}
                                            setPostalCode={setPostalCode}
                                          /> */}
                                          {/* <AdditionalFilesComponent
                                                                      reserve={reserve}
                                                                      period={reserve.period}
                                                                      setLoading={setLoading}
                                                                      showMessage={showMessage}
                                                                  /> */}

                        </>
                    ) : (

                        view == "EditTime" ? (
                            <>
                                <Row className='sectionTitle'>
                                    <Col xs={14} sm={14} md={16} lg={20} xl={20}>
                                    </Col>
                                    <Col xs={10} sm={10} md={8} lg={4} xl={4} >
                                        <Button
                                            className='btn-secondary'
                                            onClick={handleBackFromEdit}
                                            style={{ width: '100%' }} >
                                            <DoubleRightOutlined /> بازگشت
                                        </Button>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={24} sm={24} md={8} lg={7} xl={7}>
                                        <TimesComponent
                                            setLoading={setLoading}
                                            showMessage={showMessage}
                                            reserve={reserve}
                                            period={reserve.period}
                                            onTimeChanged={() => loadReserve()}
                                        />
                                    </Col>
                                    <Col xs={24} sm={24} md={16} lg={17} xl={17}>
                                        <ObjectsComponent
                                            setLoading={setLoading}
                                            showMessage={showMessage}
                                            reserve={reserve}
                                            onObjectChanged={() => loadReserve()}
                                        />
                                    </Col>
                                </Row>
                            </>
                        ) : (
                            view == "PreConfirmReserve" ?
                                <>
                                    {showSteps ?
                                        <Steps
                                            reserve={reserve}
                                            period={period}
                                            setLoading={setLoading}
                                            showMessage={showMessage}

                                            isShowNext={true}
                                            isEnableNext={true}
                                            onNextClick={() => { confirmReserve() }}
                                            nextButtonText={'تایید و ادامه'}
                                        /> : <></>}

                                    {factorFirst ?
                                        <>
                                            <br />
                                            <AFactorComponent
                                                setLoading={setLoading}
                                                showMessage={showMessage}
                                                reserveId={reserve.id}
                                                printType={printType}

                                            />
                                        </> : <></>
                                    }

                                    <Row className='sectionTitle  no-print'>
                                        <Col xs={14} sm={20} md={16} lg={20} xl={20}>
                                            <h2 >
                                                لیست نفرات
                                            </h2>
                                        </Col>
                                        <Col xs={10} sm={4} md={8} lg={4} xl={4} >
                                        {!(reserve.reserveStatus == "Completed" 
                                        || reserve.reserveStatus == "Payed"
                                        || reserve.reserveStatus == "Accepted")?
                                            <Button
                                                type="primary"
                                                onClick={() => { setView("EditOthers") }}
                                                style={{ width: '100%' }}>
                                                <EditOutlined /> ویرایش
                                            </Button>:<></>}
                                        </Col>
                                    </Row>

                                    <OthersComponent
                                        mode={'Show'}
                                        printType={printType}
                                        showTitleBar={false}
                                        setLoading={setLoading}
                                        showMessage={showMessage}
                                        reserveId={reserve.id}
                                        reserve={reserve}
                                    />
                                    <div className="no-print">
                                        <Row className='sectionTitle'>
                                            <Col xs={14} sm={20} md={16} lg={20} xl={20}>
                                                <h2 >
                                                     زمان / مکان رزرو شده
                                                </h2>
                                            </Col>
                                            <Col xs={10} sm={4} md={8} lg={4} xl={4}>
                                            {!(reserve.reserveStatus == "Completed" 
                                            || reserve.reserveStatus == "Payed"
                                            || reserve.reserveStatus == "Accepted")?

                                                <Button type="primary"
                                                    onClick={() => { setView("EditTime") }}
                                                    style={{ width: '100%' }} >
                                                    <EditOutlined /> ویرایش
                                                </Button>:<></>}

                                            </Col>
                                        </Row>
                                        <ReservePlaceAndTimeComponent 
                                        showTitle={false} 
                                        setLoading={setLoading}
                                         showMessage={showMessage}
                                          reserve={reserve} 
                                          />

                                        {/* <div className='container'>
                                            <Row wrap='wrap'>
                                                <Col xs={24} sm={8} md={8} lg={8} xl={8} className='reserve-timing-main-column'>
                                                    <div className='reserve-timing-value-title'>
                                                        رزرو شده
                                                    </div>

                                                    <div className='reserve-timing-value-column'>
                                                        <span>{reserve.objectInstance.title} </span>
                                                        <ObjectFieldsComponent
                                                            setLoading={setLoading}
                                                            showMessage={showMessage}
                                                            objectInstanceId={reserve.objectInstanceId}
                                                        />
                                                    </div>
                                                </Col>

                                                <Col xs={24} sm={8} md={8} lg={8} xl={8} className='reserve-timing-main-column'>
                                                    <div className='reserve-timing-value-title'>
                                                        بازه زمانی
                                                    </div>

                                                    <div className='reserve-timing-value-column'>
                                                        <div>
                                                            <span>از تاریخ </span>
                                                            <span>{reserve.from_Shamsi_DayOfWeek} </span>
                                                            <div style={{ display: 'inline' }} >{reserve.from_Shamsi}</div>
                                                        </div>
                                                        <div>
                                                            <span>تا تاریخ </span>
                                                            <span>{reserve.to_Shamsi_DayOfWeek} </span>
                                                            <div style={{ display: 'inline' }} >{reserve.to_Shamsi}</div>
                                                        </div>
                                                    </div>
                                                </Col>

                                                <Col xs={24} sm={8} md={8} lg={8} xl={8} className='reserve-timing-main-column'>
                                                    <div className='reserve-timing-value-title'>
                                                        دوره
                                                    </div>

                                                    <div span={24} className='reserve-timing-value-column'>
                                                        {reserve.period.title}
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div> */}
                                    </div>

                                    <br />
                                    {!factorFirst ?
                                        <AFactorComponent
                                            setLoading={setLoading}
                                            showMessage={showMessage}
                                            reserveId={reserve.id}
                                            printType={printType}

                                        /> : <></>
                                    }

                                </> :
                                (
                                    view == "ConfirmedReserve" ?
                                        <AReserveComponent
                                            setLoading={setLoading}
                                            showMessage={showMessage}
                                            reserveId={reserveId}
                                        // onBackClick={()=>{ setView('All')}}
                                        /> : <></>
                                )
                        )
                    )}
            </> : <></>
    )
}
